import React from "react";
import "./HairTrim.css"
const HairTrimFaq = () => {
  return (
    <div className="hairTrimFaqContainer">
      <div className="hairTrimFaqContent">
        <h3>Best Treatments After Trimming:</h3>
        <p>
          For an extra boost after trimming, use anti-frizz serums and natural
          oils like amla, rosemary, and coconut oil. These products help achieve
          a smooth and silky finish after every wash.
        </p>
      </div>
      <div className="hairTrimFaqContent">
        <h3>Is Scalp Massage Necessary? </h3>
        <p>
          Trimming split ends alone won't boost hair growth. A clean,
          well-massaged scalp promotes blood flow to your hair follicles,
          enhancing growth.
        </p>
      </div>
      <div className="hairTrimFaqContent">
        <h3>Will Your Hair Keep Growing If You Avoid Trimming? </h3>
        <p>
          Without regular trims, your hair may eventually stop growing due to
          split ends traveling up the hair shaft, causing breakage.
        </p>
      </div>
      <div className="hairTrimFaqContent">
        <h3>Why Does Your Hair Not Grow After a Haircut? </h3>
        <p>
          If you feel your hair isn't growing after a haircut, it might be due
          to an unhealthy diet and poor hair care routine. Ensuring you have a
          balanced diet and proper hair care is crucial for growth.
        </p>
      </div>
      <div className="hairTrimFaqContent">
        <h3>Does Cutting Your Hair Make It Longer? </h3>
        <p>
          {" "}
          Cutting your hair doesn't directly make it grow longer, as hair grows
          from the roots. However, trimming the ends prevents breakage and helps
          maintain overall hair health.
        </p>
      </div>
      <div className="hairTrimFaqContent">
        <h3>Final Takeaway: </h3>
        <p>
          While trimming your hair doesn't make it grow faster, it does keep
          your hair healthier and allows it to grow at a consistent rate.
          Regular trims and a clean scalp are essential for good hair growth.
        </p>
      </div>
    </div>
  );
};

export default HairTrimFaq;
